import es from './languages/es';
import en from './languages/enUs';
import ptBr from './languages/ptBr';

export default {
  es,
  en,
  'pt-BR': ptBr,
};



// WEBPACK FOOTER //
// ./src/i18n/messages/index.js